import { FC } from "react";
import "../../components/OrderTracking/styles.scss";
import Reconciliation from "../../components/Reconciliation";

const ReconciliationPage: FC = () => {
  return <Reconciliation />
};

export default ReconciliationPage;
